import React from 'react';

import { Button } from 'components/Buttons/Button';
import { ButtonType } from 'enums/ButtonType';
import { useAppSelector } from 'prequalificationV2/hooks/useAppSelector';
import FormHeader from 'components/FormHeader';
import { Theme } from 'enums/Theme';
import FormBody from 'components/FormBody';

import styles from './ProsperLoanTab.module.scss';
import { HEADER_TITLE } from './prosperLoanTab.constants';

const ProsperLoanTab = () => {
  const { variables: applicationVariables } = useAppSelector((state) => state.application);
  const onRedirectToProsper = () => {
    if (applicationVariables?.prosper_accepted_offer_url) {
      window.location.href = applicationVariables.prosper_accepted_offer_url;
    }
  };

  return (
    <>
      <FormHeader isBorderRounded={false} title={HEADER_TITLE} theme={Theme.Dark} />
      <FormBody formBodyClassName={styles.formBody}>
        <p className={styles.text}>Proceed to your Prosper Loan below.</p>
        <Button buttonType={ButtonType.Primary} onClick={onRedirectToProsper} className={styles.button}>
          Get Started
        </Button>
      </FormBody>
    </>
  );
};

export default ProsperLoanTab;
